<template>
  <div id="app">
    <Nav :user="user" :appName="appName" />
    <div class="container">
      <router-view />
    </div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import { auth } from "./db.js";

export default {
  name: "app",
  components: {
    Nav
  },
  data() {
    return {
      appName: 'Braeton SDA Admin Portal'
    }
  },
  mounted() {
    let loader = this.$loading.show({
      color: '#00407c'
    });
    auth().onAuthStateChanged(user => {
      const route = this.$router.currentRoute.name;
      loader.hide();
      if (user) {
        this.$store.dispatch("storeUser", user);
        if (route === "admin") this.$router.replace("dashboard");
      } 
      else {
        this.$store.dispatch("purgeUser");
      }
    });
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  }
};
</script>
<style lang="scss">
$primary: #00407c;

@import "node_modules/bootstrap/scss/bootstrap";

.btn-link {
  color: #ffffff;
  &:hover {
    color: #ffffff;
  }
}
.btn-circle.btn-md { 
            width: 50px; 
            height: 50px; 
            padding: 7px 10px; 
            border-radius: 25px; 
            font-size: 15px; 
            text-align: center; 
            &.updown {
              margin: 5px;
            }
        }
  .btn-circle.btn-xl { 
            width: 70px; 
            height: 70px; 
            padding: 10px 16px; 
            border-radius: 35px; 
            font-size: 25px; 
            text-align: center; 
        } 
    p.card-text img {
      max-width: 350px !important;
      display: flex;
      margin: 5px;
    }
</style>
